import {TStimPolarity, TStimShape} from "./TStimConfig";

export enum TStimDeviceKind {
    NeuroTracSports = "NeuroTrac Sports",
    BscPrograms = "Bsc Programs"
}


export interface IStimDevice {
    kind: TStimDeviceKind
    name: string
    description: string
    polarity?: TStimPolarity
    shape?: TStimShape
    channels: Array<string>
}

/**
 * Support Stim devices. These objects are frozen to prevent accidental runtime
 * modification.
 */
export const SupportedStimDevices: Array<IStimDevice> = [
    Object.freeze({
        kind: TStimDeviceKind.NeuroTracSports,
        name: "NeuroTrac Sports",
        description: "Asymetrical Waveform, rectangular-biphasic with zero DC current",
        polarity: TStimPolarity.Anodic,
        shape: TStimShape.BIPHASIC,
        channels: ["Channel A", "Channel B"]
    }),
    Object.freeze({
        kind: TStimDeviceKind.BscPrograms,
        name: "Bsc Programs",
        description: "Program-based stimulation",
        channels:[],
        shape: undefined,
        polarity:undefined
    }),
]


